/* THIS FILE WAS CREATED USING THE bb upload-icons COMMAND */
/* eslint-disable */
var iconLibraryIdManifest = {
  "fas": "41hFFRn9iEL",
  "fab": "31jAh0Nm3gL",
  "far": "21rGpXOMw+L"
};

export { iconLibraryIdManifest as i };
//# sourceMappingURL=iconLibraryIdManifest-CHx9RO5i.js.map
